Object.filter = (obj, predicate) => Object.keys(obj)
  .filter(key => predicate(obj[key]))
  // eslint-disable-next-line no-param-reassign,no-sequences,no-return-assign
  .reduce((res, key) => (res[key] = obj[key], res), {});

Object.filterByKey = (allowed, data) => allowed
  .reduce((obj, key) => ({
    ...obj,
    [key]: data[key],
  }), {});

Date.compareGreater = (compare, to) => compare >= to;
Date.toDate = unix => unix / (1000 * 3600 * 24);

Object.isObject = obj => obj === Object(obj);
// eslint-disable-next-line max-len
Object.isEmpty = obj => (Object.isObject(obj) ? Object.keys(obj).length === 0 && obj.constructor === Object : false);


const ticketState = (state) => {
  let stateMessage = '';
  let stateColor = '';
  if (state === 1) {
    stateMessage = 'Yeni Oluşturuldu!';
    stateColor = 'primary';
  } else if (state === 2) {
    stateMessage = 'Aktif';
    stateColor = 'success';
  } else {
    stateMessage = 'Pasif';
    stateColor = 'grey darken-3';
  }

  return {
    message: stateMessage,
    color: stateColor,
  };
};
const array_combine = function (keys, values) {
  // eslint-disable-line camelcase
  //  discuss at: http://locutus.io/php/array_combine/
  // original by: Kevin van Zonneveld (http://kvz.io)
  // improved by: Brett Zamir (http://brett-zamir.me)
  //   example 1: array_combine([0,1,2], ['kevin','van','zonneveld'])
  //   returns 1: {0: 'kevin', 1: 'van', 2: 'zonneveld'}

  const newArray = {};
  let i = 0;

  // input sanitation
  // Only accept arrays or array-like objects
  // Require arrays to have a count
  if (typeof keys !== 'object') {
    return false;
  }
  if (typeof values !== 'object') {
    return false;
  }
  if (typeof keys.length !== 'number') {
    return false;
  }
  if (typeof values.length !== 'number') {
    return false;
  }
  if (!keys.length) {
    return false;
  }

  // number of elements does not match
  if (keys.length !== values.length) {
    return false;
  }

  for (i = 0; i < keys.length; i += 1) {
    newArray[keys[i]] = values[i];
  }

  return newArray;
};
const minWithLeadingZero = dt => (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes();

const copyInput = (input, without = false) => {
  if (!without) {
    const iban = document.querySelector(input);
    iban.setAttribute('type', 'text');
    iban.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      alert('Oops, bir hata oluştu');
    }

    /* unselect the range */
    iban.setAttribute('type', 'hidden');
    window.getSelection()
      .removeAllRanges();
  } else {
    const $body = document.getElementsByTagName('body')[0];
    const secretInfo = document.getElementById(input).innerHTML;

    const $tempInput = document.createElement('INPUT');
    $body.appendChild($tempInput);
    $tempInput.setAttribute('value', secretInfo);
    $tempInput.select();
    document.execCommand('copy');
    $body.removeChild($tempInput);
  }
};

const messageTypes = [
  {
    text: 'Türkçe',
    value: 'turkce',
  },
  {
    text: 'Normal',
    value: 'normal',
  },
];

const timeStatus = [{
  k: 'now',
  v: 'Hemen Gönder',
}, {
  k: 'after',
  v: 'İleri Tarihli Gönder',
}];

const downloadFile = (response, filename) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const newBlob = new Blob([response.data], { type });

  // IE, Blob u doğrudan link olarak vermemize izin vermediği için
  // msSaveOrOpenBlob ile bizim blob u tarayıcıya hazırlatıyoruz.
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // Diğer tarayıcılarda öyle sorun olmadığı için,
  // Link vermeyi direkt bir a üzerinden yapıyoruz.
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');
  link.href = data;
  link.download = `${filename}.xlsx`;
  link.click();
  setTimeout(() => {
    // Firefox'da da çalışması için bu süreyi beklemesi gerekliymiş,
    // sebebi ise bulk downloading olayının önüne geçmek içinmiş.
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
};

export { downloadFile };
export { copyInput };
export { messageTypes as types };
export { timeStatus as sendTypes };
export { minWithLeadingZero as leadZero };
// eslint-disable-next-line camelcase
export { array_combine };
export default {
  downloadFile,
  ticketState,
  minWithLeadingZero,
  messageTypes,
  array_combine,
};
